<!--Renders the project name and all of its children, level 1, level 2 and departments-->

<div class="icons">
  <ng-container *ngIf="!isReadonly">
    <i class="fas fa-spinner fa-spin"
       *ngIf="isLoading"></i>

    <i class="clickable fas fa-trash"
       *ngIf="isDepartment && !isLoading && !isLineBusy"
       (click)="removeDepartment()"
       [matTooltip]="'TOOLTIP.DELETE.DEPARTMENT' | translate"
       matTooltipClass="pop-tooltip"></i>

    <i class="fas fa-plus"
       [class.clickable]="!isAdding"
       *ngIf="isLevel2 && !isLoading"
       (click)="addDepartment($event)"
       [matTooltip]="'TOOLTIP.ADD.DEPARTMENT' | translate"
       matTooltipClass="pop-tooltip"></i>
  </ng-container>
  <i class="info fas fa-exclamation-circle"
     *ngIf="overBudgetErrors?.length > 0"
     (click)="showOverBudgetModal()"
     [matTooltip]="'ERROR.GRID_LINE_ERRORS' | translate"
     matTooltipClass="pop-tooltip"
     position="right"
     pBadge
     [value]="''+overBudgetErrors?.length"
     severity="danger"></i>
</div>
<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
{{ label }}
